import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/strip-loader/lib/index.js?strip[]=debug,strip[]=debugger,strip[]=console.log,strip[]=console.warn!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotFound.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/strip-loader/lib/index.js?strip[]=debug,strip[]=debugger,strip[]=console.log,strip[]=console.warn!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NotFound.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/spa/NotFound.vue?vue&type=script&lang=js&
// module id = 276
// module chunks = 28